import { render } from "./SectionCardsTwoColumn.vue?vue&type=template&id=8159b360"
import script from "./SectionCardsTwoColumn.vue?vue&type=script&lang=js"
export * from "./SectionCardsTwoColumn.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3529439572/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__